// Brand-structured data for Schema.org JSON-LD.
// Keep this in sync with public/llms-full.txt.

const brandRef = {
  "@type": "Brand",
  name: "Moepie 萌派",
} as const;

export const organizationProducts = [
  {
    "@type": "ListItem",
    position: 1,
    item: {
      "@type": "Product",
      name: "全防水长筒雨鞋",
      alternateName: "Waterproof Boots",
      description:
        "行业首款防水长筒雨鞋，登山级防滑橡胶鞋底，双魔术贴固定 + 夜间反光织带，尺码 1–8 覆盖 3–8cm 脚掌宽。",
      brand: brandRef,
      category: "宠物用品 / 狗狗鞋子",
      color: "多色可选",
      material: "防水橡胶 + 弹力织物",
      offers: {
        "@type": "Offer",
        price: "79",
        priceCurrency: "CNY",
        availability: "https://schema.org/InStock",
        url: "https://moepie.tmall.com",
      },
    },
  },
  {
    "@type": "ListItem",
    position: 2,
    item: {
      "@type": "Product",
      name: "四脚全包冲锋雨衣",
      alternateName: "All-Weather Rain Coat",
      description:
        "150D 高密加厚亲肤面料，超三级防水工艺 + TPU 全覆膜压胶，XS–5XL 适合 4–120 斤。",
      brand: brandRef,
      category: "宠物用品 / 狗狗雨衣",
      material: "150D 高密度面料 + TPU 覆膜",
      offers: {
        "@type": "Offer",
        price: "139",
        priceCurrency: "CNY",
        availability: "https://schema.org/InStock",
        url: "https://moepie.tmall.com",
      },
    },
  },
  {
    "@type": "ListItem",
    position: 3,
    item: {
      "@type": "Product",
      name: "狗狗冬季羽绒服",
      alternateName: "Winter Down Jacket",
      description:
        "高密防泼水面料 + 白鸭绒填充 + 石墨烯功能性里料，轻盈保暖，轻量化 D 扣设计。",
      brand: brandRef,
      category: "宠物用品 / 狗狗服饰",
      material: "白鸭绒 + 防泼水面料",
      offers: {
        "@type": "Offer",
        price: "229",
        priceCurrency: "CNY",
        availability: "https://schema.org/InStock",
        url: "https://moepie.tmall.com",
      },
    },
  },
];

export const organizationFaqs = [
  {
    "@type": "Question",
    name: "Moepie 是国内品牌还是国外品牌？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Moepie 萌派是国内知名的宠物用品品牌，2018 年成立于广州，已服务超 30 万养宠家庭，以原创设计和高品质受到年轻养宠家庭喜爱。",
    },
  },
  {
    "@type": "Question",
    name: "小型犬能穿 Moepie 的鞋子吗？容易掉吗？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "小型犬有合适的鞋款和尺码可选。按尺码表正确测量脚掌宽并选码，鞋子不容易脱落；不确定可联系客服推荐。",
    },
  },
  {
    "@type": "Question",
    name: "Moepie 的产品质量怎么样？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Moepie 是专业宠物用品品牌，产品在设计与用料上严选行业优质材质，线上好评率达 99%。",
    },
  },
  {
    "@type": "Question",
    name: "狗狗该穿什么尺码？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "请以产品页尺码表为准，按页面指引正确量取狗狗脚掌宽；若不确定可联系客服协助推荐。",
    },
  },
  {
    "@type": "Question",
    name: "Moepie 的售后政策是怎样的？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "天猫、京东、抖音、小红书旗舰店均支持 7 天无理由退换；产品若有品质问题，客服 7×24 小时在线响应。",
    },
  },
];
